import React, { useState, useEffect } from 'react';
import styles from './PngGas.module.css';
import * as Yup from 'yup';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import CommonPincode from '../../../../components/Dashboard-res/CommonComponent/CommonPincode';
import initialImg from '../../../../images/icons/upload_new.svg';
import { StateListOptions } from '../../../../common/constants/StateList';
import PopUp from '../../../../common/components/PopUp/PopUp';
import get from 'lodash/get';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import { Formik, Form } from 'formik';
import {
  uploadUserUtilityBill,
  saveKYCUtilityAddressProof,
  UploadFileToS3,
  confirmingUserUtilityUploads,
  getUtilityAddressDetails,
  getUserKYCUtility
} from '../../../../common/constants/api';
import { GetImgComp } from '../UserVoterCard/GetImgComp';

const validationSchema = Yup.object().shape({
  file: Yup.array().when('isEditMode', {
    is: false,
    then: Yup.array()
      .min(1, 'must upload 1 files atleast')
      .required('file is required')
      .of(Yup.string().required())
  }),
  imgUrl: Yup.string().when('isEditMode', {
    is: false, // alternatively: (val) => val == true
    then: Yup.string().required(' required')
  }),

  ///
  consumerID: Yup.string().when('chooseService', {
    is: chooseService =>
      chooseService.value === 'AG' || chooseService.value === 'MG',
    then: Yup.string().required('Required')
  }),

  ///
  BPNumber: Yup.string().when('chooseService', {
    is: chooseService =>
      chooseService.value === 'IG' || chooseService.value === 'MG',
    then: Yup.string().required('Required')
  }),

  chooseService: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  address_line1: Yup.string().required('Required'),
  city: Yup.string().required('Required'),
  state: Yup.object().shape({
    value: Yup.string().required('Required')
  }),

  pincode: Yup.string()
    .required('Required')
    .max(6, 'Pincode should be 6 digit numbers')
    .matches(/\d{6}/, 'Pincode should be digits only')
});

let PngOptions = [
  {
    label: 'Adani Gas',
    value: 'AG'
  },
  {
    label: 'Indraprastha Gas',
    value: 'IG'
  },
  {
    label: 'Mahangar Gas',
    value: 'MG'
  }
];

const PngOptionObj = {
  AG: 'Adani Gas',
  IG: 'Indraprastha Gas',
  MG: 'Mahangar Gas'
};

const PngGas = props => {
  const {
    png_container,
    hide,
    png_details_container,
    align_city_state,
    align_state
  } = styles;

  return (
    <Formik
      initialValues={{
        file: [],
        imgUrl: [],
        consumerID: '',
        isEditMode: false,
        BPNumber: '',
        chooseService: { value: '', label: 'Select' },
        address_line1: '',
        address_line2: '',
        city: '',
        state: { value: '', label: 'Select city' },
        pincode: '',
        pincodeCity: '',
        pincodeState: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(data, { setSubmitting, resetForm }) => {
        setSubmitting(true);
        props.handleSubmit();
      }}
    >
      {({
        values: data,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        isSubmitting,
        setValues
      }) => {
        const [Loading, setLoading] = useState(false);
        const [LoadingFail, setLoadingFail] = useState(false);
        const [isSubmit, setSubmit] = useState(false);
        const [uploadDone, setUploadDone] = useState(false);
        const [LeadId, SetLeadId] = useState(getApplicantionInfo().leadId);
        const [ApplicantId, setApplicantId] = useState(
          getApplicantionInfo().leadApplicantId
        );

        const [showDetail, setShowDetail] = useState('');
        const [imgLinkData, setImgLinkData] = useState(null);
        const [Edit1, setEdit1] = useState(false);

        useEffect(() => {
          setUploadDone(false);
          setShowDetail(false);
          setEdit1(true);
          setFieldValue('file', []);
        }, [data.chooseService.value]);
        useEffect(() => {
          setUploadDone(false);
          setShowDetail(false);
          //
          setValues({
            ...data,
            consumerID: '',
            BPNumber: '',
            address_line1: '',
            address_line2: '',
            city: '',
            state: '',
            pincode: '',
            pincodeCity: '',
            pincodeState: ''
          });
        }, [data?.imgUrl?.[0]]);
        const shouldShowUploadButton = data.file.length == 1;
        const shouldShowUpload = data.chooseService.value !== '';

        async function UploadFile() {
          setLoading(true);
          try {
            const res = await uploadUserUtilityBill(
              data.file[0],
              LeadId,
              ApplicantId,
              'png'
            );

            if (!res.isAxiosError) {
              await UploadFileToS3(res.url, data.file[0][0]);
              const updoadedRes = await confirmingUserUtilityUploads(
                LeadId,
                ApplicantId,
                res.requestId,
                'png'
              );
              if (!updoadedRes.isAxiosError) {
                setLoading(false);
                setLoadingFail(false);
              } else {
                setLoading(true);
                setLoadingFail(true);
              }
            } else {
              setLoading(true);

              setLoadingFail({
                message: res?.error?.data?.message || 'Something went wrong !',
                status: res?.error?.data?.status
              });
            }
          } catch (err) {
            console.log(err);
          }
        }

        function getSearchParam(anyConsumerID, anyBPNumber) {
          if (data.chooseService.value === 'IG') {
            return `${data.chooseService.value}?bpNumber=${anyBPNumber}`;
          }
          if (data.chooseService.value === 'AG') {
            return `${data.chooseService.value}?consumerId=${anyConsumerID}`;
          }
          if (data.chooseService.value === 'MG') {
            return `${data.chooseService.value}?bpNumber=${anyBPNumber}&consumerId=${anyConsumerID}`;
          }

          return `${data.chooseService.value}`;
        }
        async function getPngAddressDetails() {
          const getPngAddressRes = await getUtilityAddressDetails(
            LeadId,
            ApplicantId,
            'png',
            getSearchParam(data.consumerID, data.BPNumber)
          ).catch(err => {
            setLoading(true);
            setLoadingFail({
              message: err?.response?.data?.message || 'Something went wrong !',
              status: err?.response?.data?.status
            });
          });

          setFieldValue('address_line1', getPngAddressRes?.address, '');
        }

        async function savePNGAddressProof() {
          setLoading(true);
          let body = {
            line1: data?.address_line1,
            line2: data?.address_line2,
            city: data?.city,
            state: data?.state.value,
            pinCode: data?.pincode,
            serviceProviderCode: data?.chooseService.value,
            consumerId: data?.consumerID,
            businessPartnerNumber: data?.BPNumber
          };
          try {
            const resSavePNG = await saveKYCUtilityAddressProof(
              LeadId,
              ApplicantId,
              'png',
              body
            );

            if (!resSavePNG.isAxiosError) {
              setLoading(false);
            } else {
              setLoading(true);
            }
          } catch (err) {
            console.log(err);
          }
        }
        async function getPNGAllData() {
          let isError = false;
          const res = await getUserKYCUtility(LeadId, ApplicantId, 'png').catch(
            err => {
              setLoading(true);
              setLoadingFail({
                message:
                  err?.response?.data?.message || 'Something went wrong !',
                status: err?.response?.data?.status
              });
              isError = true;
            }
          );

          if (!isError) {
            const { links, userData } = res;
            // parsing logic here
            setImgLinkData(links?.[0]);
            setValues({
              ...data,
              file: [],
              imgUrl: [],
              isEditMode: !!links?.[0],

              chooseService: {
                label: PngOptionObj[userData?.serviceProviderCode] || 'Select',
                value: userData?.serviceProviderCode || ''
              },
              consumerID: userData?.consumerId || '',
              BPNumber: userData?.businessPartnerNumber || '',
              address_line1: userData?.address?.line1 || '',
              address_line2: userData?.address?.line2 || '',
              city: userData?.address?.city || '',
              state:
                {
                  label: userData?.address?.state,
                  value: userData?.address?.state
                } || '',

              pincode: userData?.address?.pinCode || '',
              pincodeCity: '',
              pincodeState: ''
            });
            setShowDetail(true);
            setUploadDone(true);
            setEdit1(false);
          }
        }

        ////////
        useEffect(() => {
          getPNGAllData();
        }, []);
        function getLoadingMsg() {
          if (typeof LoadingFail !== 'boolean') {
            if (LoadingFail) return LoadingFail?.message;
          }
          return <p>Loading ...</p>;
        }
        return (
          <React.Fragment>
            {Loading && (
              <PopUp
                goto={LoadingFail.status == 403}
                dontClose={LoadingFail?.status == 403}
                type={LoadingFail?.message ? 'fail' : 'loading'}
                text={getLoadingMsg()}
                show={Loading}
                setShow={setLoading}
              />
            )}
            <Form
              autoComplete="off"
              onSubmit={handleSubmit}
              className="pt-2 sm:px-5 "
            >
              <div className={`${png_container}`}>
                <div className="mt-8  max-w-xs">
                  <CommonSelect sort={true}
                    name="chooseService"
                    value={data.chooseService}
                    onChange={e => {
                      setFieldValue('chooseService', e, true);
                    }}
                    options={[
                      {
                        label: 'Select',
                        value: ''
                      },
                      ...PngOptions
                    ]}
                    stylesContainer={{
                      height: '52px',
                      marginBottom: '40px',
                      fontSize: '40px'
                    }}
                    dropdownStyle={{
                      top: '55px',
                      fontSize: '16px'
                    }}
                    styleText={{
                      fontSize: '14px',
                      padding: '0 25px'
                    }}
                    touched={touched.chooseService}
                  />
                </div>
                {shouldShowUpload && (
                  <div className="flex justify-around pt-5">
                    {imgLinkData?.url && !Edit1 ? (
                      <GetImgComp
                        imgUrl={imgLinkData?.url}
                        setEdit={setEdit1}
                      />
                    ) : (
                      <GlobalUploadComp
                        data={data}
                        imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        showFullImage // boolean , to change mobile upload image view
                        initialImg={initialImg} // initial image
                        subInst="Click here to upload "
                        subtext="CHOOSE IMAGE"
                      />
                    )}
                  </div>
                )}
                {shouldShowUploadButton && (
                  <button
                    type="button"
                    className={`submitButton w-48 ${uploadDone ? 'hide' : ''}`}
                    onClick={e => {
                      UploadFile();
                      setUploadDone(true);
                    }}
                  >
                    UPLOAD
                  </button>
                )}
                {/* //{`${Edit1 ? 'hide' : ''}`} */}
                {uploadDone && (
                  <div className={`mt-8 m-auto max-w-xs`}>
                    {(data.chooseService.value == 'AG' ||
                      data.chooseService.value == 'MG') && (
                      <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                        <CommonInput
                          name="consumerID"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={data.consumerID}
                          stylesContainer={{
                            maxWidth: '100%'
                          }}
                          legendName="consumer ID"
                          error={touched.consumerID && errors.consumerID}
                          errorMsg={errors.consumerID}
                          touched={touched.consumerID}
                        />
                      </div>
                    )}
                    {(data.chooseService.value == 'IG' ||
                      data.chooseService.value == 'MG') && (
                      <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                        <CommonInput
                          name="BPNumber"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={data.BPNumber}
                          stylesContainer={{
                            maxWidth: '100%'
                          }}
                          legendName="BP Number"
                          error={touched.BPNumber && errors.BPNumber}
                          errorMsg={errors.BPNumber}
                          touched={touched.BPNumber}
                        />
                      </div>
                    )}

                    <button
                      type="button"
                      className={`submitButton w-48 ${
                        Edit1 == false ? 'hide' : ''
                      }`}
                      onClick={e => {
                        getPngAddressDetails();
                        setEdit1(false);
                      }}
                      disabled={
                        (data.chooseService.value == 'AG' &&
                          data.consumerID == '') ||
                        (data.chooseService.value == 'IG' &&
                          data.BPNumber == '') ||
                        (data.chooseService.value == 'MG' &&
                          (errors.BPNumber || errors.consumerID))
                      }
                    >
                      NEXT
                    </button>
                  </div>
                )}
                {(showDetail || imgLinkData !== 'null') &&
                  data.chooseService.value !== '' && (
                    <div className={`${Edit1 ? 'hide' : ''}`}>
                      <div
                        className={`${png_details_container} px-5 md:px-0 ${
                          Edit1 ? 'pt-12' : 'pt-0'
                        }`}
                      >
                        <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                          <CommonInput
                            name="address_line1"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={data.address_line1}
                            stylesContainer={{
                              maxWidth: '100%'
                            }}
                            legendName="Address Line 1"
                            error={
                              touched.address_line1 && errors.address_line1
                            }
                            errorMsg={errors.address_line1}
                            touched={touched.address_line1}
                          />
                        </div>
                        <div className=" mb-12 font-normal font-roboto text-sm text-black-500">
                          <CommonInput
                            name="address_line2"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={data.address_line2}
                            stylesContainer={{
                              maxWidth: '100%'
                            }}
                            legendName="Address Line 2"
                            error={
                              touched.address_line2 && errors.address_line2
                            }
                            errorMsg={errors.address_line2}
                            touched={touched.address_line2}
                          />
                        </div>
                        <div className={`${align_city_state}`}>
                          <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                            <CommonInput
                              name="city"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={data.city}
                              stylesContainer={{
                                maxWidth: '100%'
                              }}
                              legendName="City"
                              error={touched.city && errors.city}
                              errorMsg={errors.city}
                              touched={touched.city}
                            />
                          </div>
                          <div
                            className={`${align_state} mb-8 font-normal font-roboto text-sm text-black-500`}
                          >
                            <div className="text-black-600 font-roboto font-normal text-xs pb-1 md:py-0">
                              State
                            </div>

                            <CommonSelect sort={true}
                              name="state"
                              value={data.state}
                              onChange={e => {
                                setFieldValue('state', {
                                  value: e.value,
                                  label: e.value
                                });
                              }}
                              onBlur={() => {
                                setFieldTouched('state', true, true);
                              }}
                              options={StateListOptions}
                              isHoverEffect
                              stylesContainer={{
                                marginBottom: '0px',
                                fontSize: '40px',
                                height: '52px'
                              }}
                              dropdownStyle={{
                                top: '52px',
                                color: 'rgba(0,0,0,0.87)',
                                fontSize: '16px',
                                backgroundColor: '#fff',
                                alignItems: 'center',
                                fontFamily: 'Roboto',
                                fontWeight: 400
                              }}
                              styleText={{
                                fontSize: '14px',
                                padding: '0 6px',
                                backgroundColor: 'white'
                              }}
                              error={
                                touched.state &&
                                get(errors, 'state.value', false)
                              }
                              touched={touched.state}
                            />
                          </div>
                        </div>
                        <div>
                          <CommonPincode
                            name="pincode"
                            value={data.pincode}
                            onChange={e => {
                              if (
                                e.target.value.length <= 6 &&
                                !isNaN(e.target.value)
                              ) {
                                setFieldValue('pincodeCity', ''),
                                  setFieldValue('pincodeState', '');
                                handleChange(e);
                              }
                            }}
                            stylesContainer={{
                              maxWidth: '100%'
                            }}
                            error={errors?.pincode && touched?.pincode}
                            errorMsg={errors?.pincode}
                            touched={touched?.pincode}
                            onPinCodeSucessOrFailure={obj => {
                              const { err, data: pincodeData } = obj;

                              if (!err && pincodeData) {
                                setFieldValue(
                                  'pincodeCity',
                                  pincodeData.District
                                ),
                                  setFieldValue(
                                    'pincodeState',
                                    pincodeData.State
                                  );
                              } else {
                                setFieldError(
                                  'pincode',
                                  'Pincode is not valid'
                                );
                              }
                            }}
                            onBlur={e => {
                              handleBlur(e);
                            }}
                          />
                          <p className="pt-3 text-green-500 text-xs">
                            {data.pincodeCity} {data.pincodeState}
                          </p>
                        </div>
                      </div>
                      <button
                        onClick={e => {
                          savePNGAddressProof();
                          setUploadDone(true);
                        }}
                        type="submit"
                        className="submitButton w-48"
                        disabled={
                          errors.address_line1 ||
                          data.address_line1 == '' ||
                          errors.city ||
                          data.city == '' ||
                          errors?.state?.value ||
                          data?.state?.value == '' ||
                          errors.pincode ||
                          data.pincode == ''
                        }
                      >
                        Save and Verify
                      </button>
                    </div>
                  )}
              </div>
            </Form>
          </React.Fragment>
        );
      }}
    </Formik>
  );
};

export default PngGas;
